import axios from "axios";

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL_FULL,
  // Isolation app/dashboard : aucun cookie envoyé. L'auth se fait via Bearer Sanctum.
  withCredentials: false,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    "X-Requested-With": "XMLHttpRequest",
  },
  timeout: 30000,
});

// Log de la configuration initiale
// console.log("Axios configuration:", {
//   baseURL: api.defaults.baseURL,
//   withCredentials: api.defaults.withCredentials,
//   headers: api.defaults.headers,
//   timeout: api.defaults.timeout,
//   env: import.meta.env.DEV ? "development" : "production",
// });

// Intercepteur pour les requêtes
api.interceptors.request.use(
  (config) => {
    // Pour les requêtes multipart/form-data, ne pas définir Content-Type
    if (config.data instanceof FormData) {
      delete config.headers["Content-Type"];
      // console.log("FormData détecté, Content-Type supprimé");

      // Log du contenu du FormData
      for (const [key, value] of config.data.entries()) {
        // console.log(
        // "FormData dans l'intercepteur:",
        // key,
        // value instanceof File
        //   ? {
        //       name: value.name,
        //       size: value.size,
        //       type: value.type,
        //     }
        //   : value
        // );
      }
    }

    // Log de la requête
    // console.log("Axios Request:", {
    //   url: config.url,
    //   method: config.method,
    //   headers: config.headers,
    //   data: config.data instanceof FormData ? "FormData" : config.data,
    //   baseURL: config.baseURL,
    //   fullUrl: config.baseURL ? `${config.baseURL}${config.url}` : config.url,
    // });

    const token = localStorage.getItem("auth_token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    console.error("Axios Request Error:", error);
    return Promise.reject(error);
  }
);

// Intercepteur pour gérer les erreurs
api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    console.error("Axios Response Error:", {
      message: error.message,
      code: error.code,
      config: error.config
        ? {
            url: error.config.url,
            method: error.config.method,
            headers: error.config.headers,
            baseURL: error.config.baseURL,
          }
        : null,
      response: error.response
        ? {
            status: error.response.status,
            headers: error.response.headers,
            data: error.response.data,
          }
        : null,
    });

    // Gérer les erreurs 429 (Too Many Requests)
    if (error.response?.status === 429) {
      console.log('[API] 429 detected, emitting event');
      const message = error.response?.data?.message || "Vous avez effectué trop de requêtes. Veuillez patienter quelques instants avant de réessayer.";

      // Émettre un événement custom
      const event = new CustomEvent('rate-limit-exceeded', {
        detail: { message, duration: 60 }
      });
      console.log('[API] Dispatching event:', event);
      window.dispatchEvent(event);

      // Ne pas rejeter immédiatement pour laisser le modal s'afficher
      return Promise.reject(error);
    }

    if (error.response?.status === 401) {
      localStorage.removeItem("auth_token");
      localStorage.removeItem("user_data");
      window.location.href = "/login";
    } else if (error.code === "ERR_NETWORK") {
      throw new Error(
        "Erreur de connexion au serveur. Veuillez vérifier votre connexion internet et réessayer."
      );
    } else if (error.code === "ECONNABORTED") {
      throw new Error("La requête a expiré. Veuillez réessayer.");
    }
    return Promise.reject(error);
  }
);

export default api;
